import { render, staticRenderFns } from "./interactData.vue?vue&type=template&id=c604121a&scoped=true&"
import script from "./interactData.vue?vue&type=script&lang=js&"
export * from "./interactData.vue?vue&type=script&lang=js&"
import style0 from "./interactData.vue?vue&type=style&index=0&id=c604121a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c604121a",
  null
  
)

export default component.exports